export interface IGridColumn {
    name: string;
    nameType: 'string' | 'date';
    dataType: 'string' | 'number';
    dataField: string;
    excludedFromSearch: boolean;
    matchInitials?: boolean;
    duplicateIcon?: boolean;
}
